import { PageHeader } from '../../components/PageHeader';
import { TiposServicioTable } from './components/TiposServicioTable';

export function TiposServicioListPage() {
  return (
    <div>
      <PageHeader
        title="Tipos de Servicio"
        subtitle="Tipos de servicio disponibles para asignar a los servicios contratados"
      />
      <TiposServicioTable />
    </div>
  );
}
